class Tooltip {
  constructor(node, { text, size, fixedSize, noTail }) {
    this.node = node;
    this.text = text;
    // size (float): ratio of tooltip width compared to parent width * 2
    this.size = size;
    this.fixedSize = fixedSize; // Format: true|false
    this.tooltipNode = document.querySelector('.tooltip');
    this.noTail = noTail;

    this.addListeners();
  }

  hideTooltip() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.tooltipNode.className.match('show')) {
      this.tooltipNode.classList.remove('show');
    }
  }

  addListeners() {
    if (!this.node || !this.tooltipNode) return;
    this.node.addEventListener('mouseenter', () => {
      this.timeout = window.setTimeout(() => {
        this.setPosition();
        window.setTimeout(() => {
          this.tooltipNode.classList.add('show');
        }, 0);
      }, 300);
    });

    this.node.addEventListener('mouseleave', () => {
      this.hideTooltip();
    });

    this.node.addEventListener('click', event => {
      this.hideTooltip();
    });

    this.tooltipNode.addEventListener('transitionend', () => {
      if (!this.tooltipNode.className.match('show')) {
        this.tooltipNode.style.display = 'none';
      }
    });
  }

  setPosition() {
    const rect = this.node.getBoundingClientRect();
    const { width, top, left } = rect;
    const tooltipWidth = this.fixedSize ? this.size : width * this.size * 2;
    const tooltipLeft = this.calculateOffset(left, width, tooltipWidth);

    Object.assign(this.tooltipNode.style, {
      // 10px buffer between element and tooltip
      bottom: `${window.innerHeight - top + 10}px`,
      display: 'block',
      left: `${tooltipLeft}px`,
      width: `${tooltipWidth}px`,
    });

    this.tooltipNode.innerHTML = this.text;
    this.setTail();
  }

  calculateOffset(left, width, tooltipWidth) {
    const maxWidth = window.innerWidth;
    const value = this.fixedSize ? left : left - tooltipWidth / 2 + width / 2;

    if (value + tooltipWidth > maxWidth) {
      this.tooltipNode.classList.add('arrow-right');
      return maxWidth - tooltipWidth;
    }
    this.tooltipNode.classList.remove('arrow-right');
    return value;
  }

  setTail() {
    if (this.noTail && this.tooltipNode.classList.contains('tail')) {
      this.tooltipNode.classList.remove('tail');
    } else if (!this.noTail && !this.tooltipNode.classList.contains('tail')) {
      this.tooltipNode.classList.add('tail');
    }
  }
}

export default Tooltip;
